import { ConfirmDialog } from "../../ui";

type DeletePlayerDialogProps = {
  playerName: string;
  isOpen: boolean;
  onDelete: () => void;
  onClose: (update?: boolean) => void;
};

/** "Are you sure?" before removing a player: a thin wrapper round the kit's ConfirmDialog. */
const DeletePlayerDialog = (props: DeletePlayerDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    onClose={(confirmed) => props.onClose(confirmed ? true : undefined)}
    onConfirm={() => {
      // Started, not awaited: the dialog closes straight away, as it always has
      props.onDelete();
    }}
    title="Are you sure?"
    message="This action cannot be undone. If you delete this player, you will lose all his data."
    confirmLabel="Delete"
    tone="danger"
  />
);

export default DeletePlayerDialog;
